<div
  class="common-pagination-buttons"
  [class.common-pagination-buttons--large]="size === 'large'"
  [class.common-pagination-buttons--medium]="size === 'medium'"
>
  <mat-paginator
    [length]="length"
    [pageIndex]="pageIndex"
    [pageSize]="pageSize"
    [hidePageSize]="true"
    [showFirstLastButtons]="showFirstLastButtons"
    [disabled]="disabled"
    [attr.aria-label]="ariaLabel || null"
    (page)="onPage($event)"
  ></mat-paginator>
</div>